<template>
    <div class="page-footer">
        <div class="page-footer-wrapper">
            <template v-for="item in footerlist">
                <div class="page-footer-item" :class="{'active':item.ifActive}">
                    <a @click="$router.push(item.routerInfo)" class="menu-item-level-top" :class="{'menu-item-hasicon':item.iconClass}">
                        <i :class="'iconfont '+item.iconClass" v-if="item.iconClass"></i>
                        <div class="text">{{item.title}}</div>
                    </a>
                </div>
            </template>
            <!--<div class="page-footer-item">
                <a @click="$router.push({name:'home_index'})" class="menu-item-level-top menu-item-hasicon">
                    <i class="iconfont icon-home"></i>
                    <div class="text">首页</div>
                </a>
            </div>
            <div class="page-footer-item">
                <a @click="$router.push({name:'transaction_index'})" class="menu-item-level-top menu-item-hasicon">
                    <i class="iconfont icon-icon"></i>
                    <div class="text">交易</div>
                </a>
            </div>
            <div class="page-footer-item">
                <a @click="$router.push({name:'mine_index'})" class="menu-item-level-top menu-item-hasicon">
                    <i class="iconfont icon-user"></i>
                    <div class="text">我的</div>
                </a>
            </div>-->
        </div>
    </div>
</template>

<script>
import qs from "qs"
import { Validator } from 'vee-validate';

export default {
    name: 'login',
    validator: null,
    data() {
        return {
            footerlist:[
                {routerInfo:{name:'home_index'},ifActive:this.$route.name=='home_index',iconClass:'icon-home',title:'首页'},
                {routerInfo:{name:'transaction_index'},ifActive:this.$route.name=='transaction_index',iconClass:'icon-icon',title:'交易'},
                {routerInfo:{name:'mine_index'},ifActive:this.$route.name=='mine_index',iconClass:'icon-user',title:'我的'},
            ],
        };
    },
    methods: {
        init() {
            //   https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx841a97238d9e17b2&redirect_uri=http://cps.dianping.com/weiXinRedirect&response_type=code&scope=snsapi_base
            //this.$set(this, 'errors', this.validator.errors);
        },
    },
    mounted() {
        this.init();
    },
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/views/main_components/pageFooter.vue